<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { storeDeliverablesPressRevue } from "../scripts/deliverable";
    import { storeLanguage, lang_fr } from "../scripts/store";

    onMount(async () => {
        window.scrollTo(0,0);
	});

</script>
    
<style lang="scss">

    .press {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__revues {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: flex-start;
            margin: 0 32px 0 32px;
            width: 100%;
        }
        &__revue {
            margin: 0 0 50px 0;
        }
    }

    @include large {
        .press {
            &__bloc {
                cursor: url('../assets/images/paque/oeuf_07.png'), default;
            }
            &__revues {
                flex-direction: row;
            }
            &__revue {
                width: 100%;
                display: grid;
                grid-template-areas: "title subtitle date";
                grid-template-columns: 30% 50% 20%;
                gap: 15px;
                justify-content: flex-start;
                align-items: baseline;
                &__title {
                    grid-area: title;
                    &__a {
                        cursor: pointer;
                        text-decoration: none;
                    }
                }
                &__subtitle {
                    grid-area: subtitle;
                }
                &__date {
                    grid-area: date;
                }
            }
        }
    }

</style>

<div class="press">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Revue de presse"/>
    {:else}
    <PageHeader props="Press review"/>
    {/if}
    <div class="bloc press__bloc">
        <div class="press__title">
            {#if ($storeLanguage == $lang_fr)}
            Vous retrouverez ici toutes nos revues de presse mensuelles, qui recensent divers articles sur l’ouverture des systèmes d’information, en français ou en anglais.
            {:else}
            Here you will find all our monthly press reviews, which list various articles, in French or in English, on the opening of information systems.
            {/if}
            </div>
        <div class="press__revues">
            {#each $storeDeliverablesPressRevue as deliverablePress, i}
            <div class="press__revue">
                <div class="press__revue__title">
                    {#if ($storeLanguage == $lang_fr)}
                    <a class="press__revue__title__a font__h2" href="../assets/deliverables/press/{deliverablePress.id}_{deliverablePress.file_deliverable}" target="_blank" title="Télécharger la revue">
                        {deliverablePress.title_fr}
                    </a><span class="press__revue__title__arrow font__h2">&darr</span>
                    {:else}
                    <a class="press__revue__title__a font__h2" href="../assets/deliverables/press/{deliverablePress.id}_{deliverablePress.file_deliverable}" target="_blank" title="Download the review">
                        {deliverablePress.title_en}
                    </a><span class="press__revue__title__arrow font__h2">&darr</span>
                    {/if}
                </div>
                <div class="press__revue__subtitle font__h4">
                    {#if ($storeLanguage == $lang_fr)}
                    {deliverablePress.subtitle_fr}
                    {:else}
                    {deliverablePress.subtitle_en}
                    {/if}
                </div>
                <div class="press__revue__date font__h4">
                    {deliverablePress.date_deliverable}
                </div>
            </div>
            {/each}
        </div>    
    </div>
</div>
